import { memo } from 'react'
import { useRecoilValue } from 'recoil'
import { profitState, useDeleteProfit } from '../../states/profits-state'
import moment from 'moment'
interface Props {
  readonly id: string
}

const Component = (props: Props) => {
  const { id } = props
  const profit = useRecoilValue(profitState(id))

  const deleteProfit = useDeleteProfit()

  const handleRemove = (): void => {
    void deleteProfit(id)
  }

  return (
    <tr>
      <td>{moment(profit?.realizedAt).format('YYYY-MM-DD HH:mm')}</td>
      <td>
        {parseFloat(profit?.amount?.toString() as string).toFixed(2)} {profit?.currency?.code}
      </td>
      <td>
        <button className="btn btn-sm btn-warning" onClick={handleRemove}>
          Delete
        </button>
      </td>
    </tr>
  )
}

export const ProfitsTableItem = memo(Component)